import type {Dispatch} from 'react'
import {
  setOnboardingDashboardInfo,
  setBuildPipelines,
  setBuildDurationThreshold,
  setDeployPipelines,
  setRepos,
  setAppsecs,
  setSecurities,
  setCodeAnalysis,
  setQAMetrics,
  setFeatures,
  initialState as onboardingDashboardInitialState,
} from './onboardingSlices'
import {
  setBuildPipelinesV2,
  setBuildDurationThresholdV2,
  setDeployPipelinesV2,
  setReposV2,
  setSecurityAnalysisV2,
} from './onboardingSlicesV2'
import {initialState, setProgramOnboarding, setOldProgramReference} from './programOnboardingSlice'

/**
 * Resets all onboarding-related Redux slices to their initial state.
 * Call this before starting a new onboarding flow.
 */
export function resetAllOnboardingSlices(dispatch: Dispatch<any>) {
  dispatch(
    setOnboardingDashboardInfo({
      ...onboardingDashboardInitialState,
      productDashboardId: undefined,
      programDashboardName: undefined,
      configurationItemBusAppName: undefined,
    }),
  )
  dispatch(setBuildPipelines([]))
  dispatch(setBuildDurationThreshold(''))
  dispatch(setDeployPipelines([{deployJob: '', deployProdBranch: '', deployHotfixBranch: '', deployProdEnvSuffix: ''}]))
  dispatch(setRepos([{repoUrl: '', branches: ['']}]))
  dispatch(setAppsecs([]))
  dispatch(setSecurities([]))
  dispatch(setQAMetrics([{adoBoard: '', buildPipeline: ''}]))
  dispatch(setFeatures([]))
  dispatch(setProgramOnboarding({...initialState}))
  dispatch(setOldProgramReference({oldProductId: undefined, linkAction: '', oldConfigurationItemName: undefined}))
  // Reset V2 slices
  dispatch(setBuildPipelinesV2([]))
  dispatch(setBuildDurationThresholdV2(''))
  dispatch(
    setDeployPipelinesV2([
      {
        deployJob: '',
        deployProdBranch: '',
        deployHotfixBranch: '',
        deployProdEnvSuffix: '',
        organization: '',
        projectName: '',
        id: '',
      },
    ]),
  )
  dispatch(setReposV2([{repoUrl: '', branches: [''], id: ''}]))
  dispatch(setSecurityAnalysisV2([{organization: '', projectName: '', url: '', id: ''}]))
  dispatch(setCodeAnalysis([]))
}

/**
 * V2: Resets all onboarding-related Redux slices including codeAnalysisV2.
 * Used by the v2 onboarding flow (TeamsDashboardV2).
 */
export function resetAllOnboardingSlicesV2(dispatch: Dispatch<any>) {
  dispatch(
    setOnboardingDashboardInfo({
      ...onboardingDashboardInitialState,
      productDashboardId: undefined,
      programDashboardName: undefined,
      configurationItemBusAppName: undefined,
    }),
  )
  dispatch(setBuildPipelines([]))
  dispatch(setBuildDurationThreshold(''))
  dispatch(setDeployPipelines([{deployJob: '', deployProdBranch: '', deployHotfixBranch: '', deployProdEnvSuffix: ''}]))
  dispatch(setRepos([{repoUrl: '', branches: ['']}]))
  dispatch(setAppsecs([]))
  dispatch(setCodeAnalysis([]))
  dispatch(setQAMetrics([{adoBoard: '', buildPipeline: ''}]))
  dispatch(setFeatures([]))
  dispatch(setProgramOnboarding({...initialState}))
  dispatch(setOldProgramReference({oldProductId: undefined, linkAction: '', oldConfigurationItemName: undefined}))
  // Reset V2 slices
  dispatch(setBuildPipelinesV2([]))
  dispatch(setBuildDurationThresholdV2(''))
  dispatch(
    setDeployPipelinesV2([
      {
        deployJob: '',
        deployProdBranch: '',
        deployHotfixBranch: '',
        deployProdEnvSuffix: '',
        organization: '',
        projectName: '',
        id: '',
      },
    ]),
  )
  dispatch(setReposV2([{repoUrl: '', branches: [''], id: ''}]))
  dispatch(setSecurityAnalysisV2([{organization: '', projectName: '', url: '', id: ''}]))
}
